export { DispensaryCollectionsPage } from './collections';
